import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
import vuecookie from 'vue-cookies'

const actions = {
    /**
     * called from the Profile Settings user page on profile info change
     */
    updateProfileInfo(context, data){
        axios.post(`${backendUrl()}/updateProfileInfo`,
            {
                id: context.getters.getUserDetails.id,
                token: context.getters.allTemplateDetails.token,
                newUsername: data.newUsername,
                newName: data.newName,
                newTelephone: data.newTelephone,
                newFax: data.newFax,
                profilePass: data.profilePass
            },
            {
                headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
            }).then(response => {
                if(response.data.status == 'error' &&  response.data.key == 'userProfileInfoUpdateError'){
                    context.commit('setValidationErrors',response.data.errors)
                    return;
                }
                context.dispatch('handleResponse', response)
                if(response.data.status != 'error') {
                    let userDetails = context.getters.getUserDetails
                    if (response.data.username) {
                        userDetails.username = response.data.username
                    }
                    if (response.data.name) {
                        userDetails.name = response.data.name
                    }
                    if (response.data.telephone) {
                        userDetails.telephone = response.data.telephone
                    }
                    if (response.data.fax) {
                        userDetails.fax = response.data.fax
                    }
                    context.commit('userDetails', userDetails)
                }
                let showResponses = context.getters.getShowResponses
                showResponses.push('showProfileInfoResponse')
                context.commit('setShowResponses', showResponses)
            })
            .catch(() => {
                let showResponses = context.getters.getShowResponses
                showResponses.push('showProfileInfoResponse')
                context.commit('setShowResponses', showResponses)
        })
    },
    /**
     * called from the Profile Settings user page on e-mail change
     */
    updateEmail(context, data){
        axios.post(`${backendUrl()}/updateUserEmail`,
            {
                id: context.getters.getUserDetails.id,
                token: context.getters.allTemplateDetails.token,
                newEmail: data.newEmail,
                confirmEmail: data.confirmEmail,
                emailPass: data.emailPass
            },
            {
                headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
            }).then(response => {
                context.dispatch('handleResponse', response)

                let userDetails = context.getters.getUserDetails
                userDetails.email = response.data.newEmail
                let showResponses = context.getters.getShowResponses

                showResponses.push('showProfileEmailResponse')
                context.commit('setShowResponses', showResponses)
            })
            .catch(() => {
                let showResponses = context.getters.getShowResponses
                showResponses.push('showProfileEmailResponse')
                context.commit('setShowResponses', showResponses)
        })
    },
    /**
     * called from the Profile Settings user page on password change
     */
    updatePassword(context, data){
        axios.post(`${backendUrl()}/updateUserPassword`,
            {
                id: context.getters.getUserDetails.id,
                token: context.getters.allTemplateDetails.token,
                oldPass: data.oldPass,
                newPass: data.newPass,
                newPassConfirm: data.newPassConfirm,
                passHint: data.passHint
            },
            {
                headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
            }).then(response => {
            if(response.data.status == 'error' &&  response.data.key == 'userPasswordUpdateError'){
                context.commit('setValidationErrors',response.data.errors)
                return;
            }

            context.dispatch('handleResponse', response)

            let showResponses = context.getters.getShowResponses
            showResponses.push('showProfilePasswordResponse')

            context.commit('setShowResponses', showResponses)
            })
            .catch(() => {
                let showResponses = context.getters.getShowResponses
                showResponses.push('showProfilePasswordResponse')
                context.commit('setShowResponses', showResponses)
        })
    },

    updateUserPicture(context, formData) {
        axios.post(`${backendUrl()}/updateUserPicture`, formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': "bearer " +  vuecookie.get('token')
                }
            }).then(response => {
                context.dispatch('handleResponse', response)
                if(response.data.pictureUrl) {
                    context.commit('setUserProfilePicture',response.data.pictureUrl)
                }
            })
    },

    sendUserPasswordHint(context, email) {
        axios.post(`${backendUrl()}/sendUserPasswordHint`, { userEmail: email }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },

    sendUserPasswordReminder(context, email) {
        axios.post(`${backendUrl()}/sendUserPasswordReminder`, { userEmail: email }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },

    async retrieveUserEmailHint(context, data) {
        return await axios.post(`${backendUrl()}/retrieveUserEmailHint`, 
        {
            customerReference: data.customerReference,
            userPassword: data.userPassword
        })
        .then(response => {
            if(response.data.status == 'error') {
                context.dispatch('handleResponse', response)
            }
            
            return response.data
        })
    },

    retrieveUserLoginDetails(context, email){
        axios.post(`${backendUrl()}/retrieveUserLoginDetails`, 
        {
            userEmail: email,
            token:context.getters.allTemplateDetails.token
        })
        .then(response => {
            context.dispatch('handleResponse', response)
        })
    },

    async sendFeedback(context, data) {
        await axios.post(`${backendUrl()}/sendFeedback`, data, {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response)
        })
    },

    async getBlacklistedUsers( context, data ) {
        return await axios.post(`${backendUrl()}/getBlacklistedUsers`, data, {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async sendMassBlacklistRemovalRequest( context, data ) {
        return await axios.post(`${backendUrl()}/sendMassBlacklistRemovalRequest`, data, {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            context.dispatch('handleResponse', response)
            return response.data
        })
    },

    async sendUserAgreement(context, data) {
        return await axios.post(`${backendUrl()}/sendUserAgreement`, data, {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async rejectUserAgreement(context, data) {
        return await axios.post(`${backendUrl()}/rejectUserAgreement`, data, {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    },

    async getUserAgreementStatus(context) {
        return await axios.post(`${backendUrl()}/getUserAgreementStatus`, null, {
            headers: { 'Authorization': "bearer " +  vuecookie.get('token') }
        }).then(response => {
            return response.data
        })
    }
};

export default {
    actions
}
